module.exports = "# Crop and Resize Images Online\r\n\r\nUpload files below to start crop, resize or compress your images\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/containers/Features/masthead.md
// module id = 1172
// module chunks = 0